import { render, staticRenderFns } from "./projectsVisualizer.vue?vue&type=template&id=e121a8e2&scoped=true"
import script from "./projectsVisualizer.vue?vue&type=script&lang=js"
export * from "./projectsVisualizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e121a8e2",
  null
  
)

export default component.exports